import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-divider',
    templateUrl: './toolbar-button-divider.component.html',
    styleUrls: ['./toolbar-button-divider.component.scss'],
    imports: [MatDivider]
})
export class ToolbarButtonDividerComponent {}
